<a [routerLink]="homepageUrl">
  <img src="{{url$ | async}}" height="37px" width="229px" alt="Siemens Gamesa Renewable Energy">
</a>